<script>
import {
  iFeaturedIcon,
  iFeaturedIconSizes,
  iFeaturedIconTypes,
  iIcon,
} from '@inscribe/signal';

export default {
  components: {
    iFeaturedIcon,
    iIcon,
  },
  props: {
    icon: {
      type: String,
      default: 'small_solid_alert_triangle',
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    hasIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iFeaturedIconSizes,
      iFeaturedIconTypes,
    };
  },

  methods: {
    onClick() {
      this.$emit('on-button-click');
    },
  },
};
</script>

<template>
  <button
    class="summary-button d-flex align-items-center i-p-8 i-gap-6"
    @click="onClick"
  >
    <slot name="icon"></slot>
    <i-featured-icon
      v-if="hasIcon"
      :size="iFeaturedIconSizes.MD"
      :symbol="icon"
      :type="iFeaturedIconTypes.ERROR"
    ></i-featured-icon>
    <div class="text d-flex flex-column flex-grow-1 align-items-start i-gap-1">
      <div class="title i-text-button-3 i-text-neutral-120">{{ title }}</div>
      <div class="subtitle i-text-body-3 i-text-neutral-110">
        {{ subtitle }}
      </div>
    </div>
    <i-icon
      symbol="medium-chevron-right"
      class="i-text-neutral-90"
      :size="20"
    ></i-icon>
  </button>
</template>

<style lang="scss" scoped>
.summary-button {
  height: 64px;
  background: white;
  border: 0;
  cursor: pointer;

  &:hover {
    background: $light-neutral-20;
  }

  &:first-of-type {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  &:last-of-type {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
}
</style>
